module.exports = __webpack_public_path__ + "img/road.3e4db945.svg";